import { Box, Button, Typography } from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import { Mode, modeIntervals } from "../util/keys";
import Plus from '@material-ui/icons/Add';
import Minus from '@material-ui/icons/Remove';

export type Chord = { inversion: number, octave: number, number: number | null }

export type Props = {
    mode: Mode,
    chord: number | null
    inversion?: number
    octave?: number
    active?: boolean
    onSelected: (data: Chord) => void
}

const ChordSelector: React.FC<Props> = ({ mode = 'ionian', chord = null, onSelected, inversion = 0, octave = 0, active = false }) => {
    const interval = modeIntervals[mode]

    const data = {
        number: chord,
        inversion, octave
    }

    return <Box>
        <Box border={1} borderColor={active ? 'primary.main' : 'rgba(0,0,0,0)'} padding={1} boxSizing="border-box">
            {interval.map((interval, i) => <Box display="flex" flexDirection="column" marginTop={.25} marginBottom={0} key={interval}>
                <Button onClick={() => onSelected({ ...data, number: i })} variant={chord === i ? "contained" : "outlined"} color={chord === i ? 'primary' : undefined}>{interval}</Button>
            </Box>)}
        </Box>
        <Box display="flex" justifyContent="space-between">
            <Box display="flex">
                <Box>
                    <IconButton onClick={() => onSelected({...data, inversion: inversion-1})} color="primary">
                        <Minus fontSize="inherit" />
                    </IconButton>
                </Box>
                <Box textAlign="center">
                    <Typography>Inversion</Typography>
                    <Typography variant="h6">{inversion}</Typography>
                </Box>
                <Box>
                    <IconButton onClick={() => onSelected({...data, inversion: inversion+1})} color="primary">
                        <Plus fontSize="inherit" />
                    </IconButton>
                </Box>
            </Box>
            <Box display="flex">
                <Box>
                    <IconButton onClick={() => onSelected({...data, octave: octave-1})} color="primary">
                        <Minus fontSize="inherit" />
                    </IconButton>
                </Box>
                <Box textAlign="center">
                    <Typography>Octave</Typography>
                    <Typography variant="h6">{octave}</Typography>
                </Box>
                <Box>
                    <IconButton onClick={() => onSelected({...data, octave: octave+1})} color="primary">
                        <Plus fontSize="inherit" />
                    </IconButton>
                </Box>
            </Box>
        </Box>
    </Box>
}

export default ChordSelector;